import script from "./FleetInventoryBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./FleetInventoryBoard.vue?vue&type=script&setup=true&lang=js"

import "./FleetInventoryBoard.vue?vue&type=style&index=0&id=5120e0a8&lang=scss"

const __exports__ = script;

export default __exports__